import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import './autoki-remote.css'

const AutokiRemote = (props) => {
    const history = useHistory()
    const [deviceConnected, setDeviceConnected] = useState(false)
    const [motorSpeed, setMotorSpeed] = useState(0)
    const [direction, setDirection] = useState('forward')
    const [isMoving, setIsMoving] = useState(false)

    useEffect(() => {
        // Check if device is connected via WebSerial
        const device = sessionStorage.getItem('connectedDevice')
        if (device === 'Autoki') {
            setDeviceConnected(true)
        }
    }, [])

    const handleMotorControl = (speed, dir) => {
        setMotorSpeed(speed)
        setDirection(dir)
        setIsMoving(speed > 0)

        // Send command to device via WebSerial
        // Example: sendCommand(`MOTOR:${speed}:${dir}`)
        console.log(`Motor Control - Speed: ${speed}, Direction: ${dir}`)
    }

    const handleSpeedChange = (e) => {
        const speed = parseInt(e.target.value)
        setMotorSpeed(speed)
        if (speed > 0) {
            handleMotorControl(speed, direction)
        } else {
            setIsMoving(false)
        }
    }

    const handleBack = () => {
        history.push('/appMode/selectHardware')
    }

    return (
        <div className="autoki-remote-container">
            <div className="remote-header">
                <h1>Autoki Remote Control</h1>
                <button onClick={handleBack} className="back-btn">
                    ← Back
                </button>
            </div>

            <div className="connection-status">
                <div
                    className={`status-indicator ${deviceConnected ? 'connected' : 'disconnected'}`}
                >
                    {deviceConnected ? '🟢 Connected' : '🔴 Disconnected'}
                </div>
            </div>

            <div className="remote-content">
                <div className="motor-control-section">
                    <h2>Motor Control</h2>

                    <div className="direction-buttons">
                        <button
                            onClick={() => handleMotorControl(100, 'forward')}
                            className={`direction-btn forward ${direction === 'forward' && isMoving ? 'active' : ''}`}
                        >
                            ⬆️ Forward
                        </button>
                    </div>

                    <div className="side-buttons">
                        <button
                            onClick={() => handleMotorControl(100, 'left')}
                            className={`direction-btn left ${direction === 'left' && isMoving ? 'active' : ''}`}
                        >
                            ⬅️ Left
                        </button>

                        <button
                            onClick={() => handleMotorControl(0, 'stop')}
                            className={`direction-btn stop ${!isMoving ? 'active' : ''}`}
                        >
                            ⏹️ Stop
                        </button>

                        <button
                            onClick={() => handleMotorControl(100, 'right')}
                            className={`direction-btn right ${direction === 'right' && isMoving ? 'active' : ''}`}
                        >
                            Right ➡️
                        </button>
                    </div>

                    <div className="direction-buttons">
                        <button
                            onClick={() => handleMotorControl(100, 'backward')}
                            className={`direction-btn backward ${direction === 'backward' && isMoving ? 'active' : ''}`}
                        >
                            ⬇️ Backward
                        </button>
                    </div>
                </div>

                <div className="speed-control-section">
                    <h2>Speed Control</h2>
                    <div className="speed-slider">
                        <input
                            type="range"
                            min="0"
                            max="100"
                            value={motorSpeed}
                            onChange={handleSpeedChange}
                            className="slider"
                        />
                        <div className="speed-display">
                            <span className="speed-value">{motorSpeed}%</span>
                        </div>
                    </div>
                </div>

                <div className="status-section">
                    <h3>Current Status</h3>
                    <div className="status-info">
                        <p>
                            <strong>Motor Speed:</strong> {motorSpeed}%
                        </p>
                        <p>
                            <strong>Direction:</strong>{' '}
                            {direction.toUpperCase()}
                        </p>
                        <p>
                            <strong>Status:</strong>{' '}
                            {isMoving ? '🚀 Moving' : '⏸️ Stopped'}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AutokiRemote
